module.exports = __webpack_public_path__ + "img/08_L1.ff7c51f5.svg";